export class UsageTrackingService {
  static readonly MAX_USES_PER_DAY = 3;

  private static readonly STORAGE_KEY = 'spell_checker_usage_V2';

  static checkDailyUsage(isRecheck: boolean = false): boolean {
    if (isRecheck) return true; // Rechecks não contam para o limite

    const today = new Date().toDateString();
    const usage = this.getUsageData();

    if (usage.date !== today) {
      // Reset contador para novo dia
      this.resetUsage();
      this.incrementUsage();
      return true;
    }

    if (usage.count >= this.MAX_USES_PER_DAY) {
      return false;
    }

    this.incrementUsage();
    return true;
  }

  static checkAndResetIfNewDay(): boolean {
    const today = new Date().toDateString();
    const usage = this.getUsageData();

    if (usage.date !== today) {
      this.resetUsage();
      return true;
    }

    return usage.count < this.MAX_USES_PER_DAY;
  }

  static hasAvailableUsage(): boolean {
    return this.checkAndResetIfNewDay();
  }

  static getUsedChecks(): number {
    return this.getUsageData().count;
  }

  private static getUsageData(): { date: string; count: number } {
    const stored = localStorage.getItem(this.STORAGE_KEY);
    if (!stored) {
      return { date: new Date().toDateString(), count: 0 };
    }
    return JSON.parse(stored);
  }

  private static incrementUsage(): void {
    const usage = this.getUsageData();
    usage.count += 1;
    localStorage.setItem(this.STORAGE_KEY, JSON.stringify(usage));
  }

  private static resetUsage(): void {
    const usage = { date: new Date().toDateString(), count: 0 };
    localStorage.setItem(this.STORAGE_KEY, JSON.stringify(usage));
  }
}
